import { render, staticRenderFns } from "./PSkillTag.vue?vue&type=template&id=00fc40ce&scoped=true&"
import script from "./PSkillTag.vue?vue&type=script&lang=ts&"
export * from "./PSkillTag.vue?vue&type=script&lang=ts&"
import style0 from "./PSkillTag.vue?vue&type=style&index=0&id=00fc40ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc40ce",
  null
  
)

export default component.exports